module.exports = __webpack_public_path__ + "static/media/SWITCHING-YOUR-CAR-682x400.5ac1b66b.jpg";